import {
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
  fromInt2ii0rejb1w62w as fromInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Buffergs925ekssbch as Buffer } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import {
  awaitContent$default2jefvu0cvwa0w as awaitContent$default,
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
} from './ByteReadChannel.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function transferFromDelegate($this) {
  updateConsumed($this);
  var appended = $this.f4l_1.m4g($this.e4l_1.f4j());
  $this.g4l_1 = add($this.g4l_1, appended);
}
function updateConsumed($this) {
  $this.h4l_1 = add($this.h4l_1, subtract($this.g4l_1, $this.f4l_1.q2()));
  $this.g4l_1 = $this.f4l_1.q2();
}
var CountedByteReadChannelClass;
function CountedByteReadChannel() {
  if (CountedByteReadChannelClass === VOID) {
    class $ {
      constructor(delegate) {
        this.e4l_1 = delegate;
        this.f4l_1 = new (Buffer())();
        this.g4l_1 = 0n;
        this.h4l_1 = 0n;
      }
      i4l() {
        updateConsumed(this);
        return this.h4l_1;
      }
      k4j() {
        return this.e4l_1.k4j();
      }
      m4j() {
        return this.f4l_1.e3y() && this.e4l_1.m4j();
      }
      f4j() {
        transferFromDelegate(this);
        return this.f4l_1;
      }
      *n4j(min, $completion) {
        if (this.f4j().q2() >= fromInt(min)) {
          return true;
        }
        if (yield* this.e4l_1.n4j(min, $completion)) {
          transferFromDelegate(this);
          return true;
        }
        return false;
      }
      x4j(cause) {
        this.e4l_1.x4j(cause);
        this.f4l_1.l6();
      }
    }
    protoOf($).t4j = awaitContent$default;
    initMetadataForClass($, 'CountedByteReadChannel', VOID, VOID, [ByteReadChannel()], [1]);
    CountedByteReadChannelClass = $;
  }
  return CountedByteReadChannelClass;
}
function counted(_this__u8e3s4) {
  return new (CountedByteReadChannel())(_this__u8e3s4);
}
//region block: exports
export {
  counted as counted3iniv3aql3f9n,
};
//endregion

//# sourceMappingURL=CountedByteReadChannel.mjs.map
